module.exports = __webpack_public_path__ + "img/lt.19dad673.jpg";